// Ward codes are entered inconsistently: the same ward appears as "52",
// "NO52", "N052", "052" or the number 52. They all mean ward 52. Reduce any
// spelling to the bare number so wards group, sort and display as one.
export function normalizeWard(value) {
  if (value == null) return null;
  const match = String(value).match(/\d+/);
  return match ? Number(match[0]) : null;
}
